(function() {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initJupiter);
    else initJupiter();
    function initJupiter() {
        if (window.Jupiter) window.Jupiter.init({
            displayMode: "widget",
            formProps: {
                initialInputMint: "So11111111111111111111111111111111111111112",
                initialOutputMint: "MEMEESWgGAcYeFpNbXYqG41P9ja5sWapb62ijtfQbMS",
                fixedMint: "MEMEESWgGAcYeFpNbXYqG41P9ja5sWapb62ijtfQbMS"
            }
        });
        else console.error("Jupiter plugin failed to load.");
    }
})();

//# sourceMappingURL=fuko.db996fa3.js.map
